import { FC, memo } from "react"
import { useFormContext } from '../forms/form'
import FieldError, { useFieldValidity } from './fieldError'

interface CheckboxInputProps {
    label: string
    checked: boolean | string
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    required?: boolean
    disabled?: boolean
    helperText?: string
}

const CheckboxInput: FC<CheckboxInputProps> = ({ label, checked, onChange, required = false, disabled = false, helperText }) => {
    const isChecked = typeof checked === 'string' ? checked === 'true' : checked
    const { disableInputs, isLoading } = useFormContext()
    const { errorMessage, isInvalid, fieldClassName, onBlur, onChange: onValidityChange, onInvalid } = useFieldValidity()
    const isDisabled = disabled || disableInputs

    return (
        <div className="input-holder">
            <label className={`p-0 flex w-fit max-w-full flex-row items-center gap-x-2 min-w-0 ${isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
                <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => {
                        onValidityChange(e)
                        onChange(e)
                    }}
                    onBlur={onBlur}
                    onInvalid={onInvalid}
                    required={required}
                    disabled={isDisabled}
                    className={`${fieldClassName} h-5 w-5 shrink-0 accent-customSecondary ${isLoading ? 'animate-pulse' : ''} ${isInvalid ? '!border-[#FF4747]' : ''}`}
                />
                <span className="min-w-0">{label}{required ? '*' : ''}</span>
            </label>
            <FieldError message={errorMessage} />
            {helperText && (
                <div className="text-xs text-gray-500 mt-1">
                    {helperText}
                </div>
            )}
        </div>
    )
}

export default memo(CheckboxInput)
